import React from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';
function PopChangeKey(props) {
  const {open, close} = props;

  return (
    <Modal open={open} close={close} popSize="s" type="com_input com_manage_company">
      <h2 className="pop_tit">홍보키 변경 요청</h2>
      <div className="content_container scroll mb_no">
        <ul className="com_input_sec">
          <li>
            <section className="com_board_search end">
              <article className="search full">
                <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                <button className="com_btn gray ws s icon_search"></button>
              </article>
            </section>
          </li>
          <li className="input_field">
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="com_blue_txt">홍학생103 (고3ㆍ본사 ) </span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <span className="cont">010-1234-134</span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">김담임445</span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <table className="com_board_list">
              <colgroup>
                <col width="40" />
                <col width="auto" />
                <col width="70" />
                <col width="80" />
                <col width="80" />
                <col width="80" />
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" id="chkAll" className="com_chk" />
                    <label htmlFor="chkAll"></label>
                  </th>
                  <th>등록일</th>
                  <th>과목</th>
                  <th>기존 홍보키</th>
                  <th>영업형태</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(4)].map((i, idx) => (
                  <tr key={idx}>
                    <td>
                      <input type="checkbox" id={`chk${idx}`} className="com_chk" />
                      <label htmlFor={`chk${idx}`}></label>
                    </td>
                    <td>2023, 05, 12</td>
                    <td>수학</td>
                    <td>최홍보123</td>
                    <td>소개</td>
                    <td>진행중</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </li>
          <li className="tit_field">변경할 홍보키 입력</li>
          <li className="input_field">
            <section className="com_board_search end">
              <article className="search full">
                <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                <button className="com_btn gray ws s icon_search"></button>
              </article>
            </section>
          </li>
          <li className="input_field">
            <input type="text" defaultValue={`김홍보123`} className="input" />
          </li>
          <li className="tit_field">증빙서류 및 사유 입력</li>
          <li>
            <textarea name="" id="" placeholder="사유 입력"></textarea>
          </li>
          <li>
            <div className="upload_wrap">
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
              </div>
              <ul className="file_list">
                <li>
                  <div className="com_input_upload">
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      <button type="button" className="btn_down" onClick={() => {}}></button>
                    </p>
                  </div>
                </li>
                <li>
                  <div className="com_input_upload">
                    <p className="file">
                      <span className="txt">File name.pdf</span>
                      <button type="button" className="btn_del_file" onClick={() => {}}></button>
                      <button type="button" className="btn_down" onClick={() => {}}></button>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <hr className="com_divider" />
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopChangeKey;
